package com.vizio.redwolf.utils.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import kotlin.js.JsExport

@Serializable
@JsExport
data class PayFailureResponse(
    @SerialName("type") val type: String = "UNKNOWN_TYPE",
    @SerialName("title") val title: String = "UNKNOWN_TITLE",
    @SerialName("status") val status: Int = -1,
    @SerialName("statusCode") val statusCode: Int? = null,
    @SerialName("message") val message: String? = null,
    @SerialName("detail") val detail: String? = null,
    @SerialName("traceId") val traceId: String? = null,
    @SerialName("email") val email: String? = null,
    @SerialName("authStatus") val authStatus: String? = null,
    @SerialName("vzAuthCode") val vzAuthCode: String? = null
)